import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { followLink } from '@/lib/homeLayout';

const HERO_IMAGE = 'https://media.base44.com/images/public/6958216a4cd06732f9f425e2/6a3138404_generated_ede42dc8.png';

export default function DesktopHero({ hero, s, theme }) {
  const navigate = useNavigate();
  const image = HERO_IMAGE;

  return (
    <section className="relative h-[30vh] min-h-[220px] md:h-[40vh] md:min-h-[300px] lg:h-[60vh] lg:min-h-[420px] overflow-hidden" style={{ background: theme.primary_color }}>
      {image && (
        <img src={image} alt="" aria-hidden="true" fetchpriority="high" className="absolute inset-0 w-full h-full object-cover brightness-125" />
      )}
      <div className="absolute inset-0 bg-black/20" />
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.9, ease: 'easeOut' }}
        className="relative h-full px-6 lg:px-8 flex flex-col items-center justify-center text-center" style={{ color: s.text_color }}>
        <h1 className="text-2xl md:text-4xl lg:text-5xl xl:text-6xl uppercase leading-tight mb-2 md:mb-4 tracking-wide" style={{ fontFamily: theme.heading_font }}>{s.heading}</h1>
        <p className="text-base md:text-2xl lg:text-3xl font-bold uppercase tracking-wide mb-5 md:mb-8 lg:mb-10" style={{ fontFamily: theme.heading_font }}>{s.subheading}</p>
        {s.button_text && (
          <button onClick={() => followLink(s.button_link, navigate)}
            className="px-6 py-2 md:px-8 md:py-3 text-sm md:text-base text-black rounded font-semibold hover:opacity-90 transition-opacity" style={{ background: '#F7F3E6' }}>
            {s.button_text}
          </button>
        )}
      </motion.div>
    </section>
  );
}